import { User } from './data/User';

export class RootScopeDeclare {
    pageName: string;
    contentAreaHeight: number;
    contentHeight: number;
    leftNavHeight: number;
    footerHeight: number;
    screenSize: string;
    selectedLang: string;
    enablePopup:boolean;
    isRTL: boolean;
    serviceBasePath:String;
    profileImageUrl:String;
    isCookieBannerClosed:boolean;
    isAuthenticated: boolean;
    currentFacility:any;
    lastSelectedConsole:string;
    lastSelectedFacility:string;
    popupData:any;
    managerData:any;
    countryList:Map<String,String>;
    consoleRights:Map<String,any>;
    currentlySelectedFacilityId:string;
    translationsLoaded: boolean;
    isPageHasUnsavedChanges: boolean;
    isFromFacilitySelection: string;
    showCustomModal: boolean;    
    customPopupData: {};
    unsavedChangesPopupData: {};
    showUnSavedChangesModal: boolean;
    pathToNavigate: string | any;
    pathToNavigateQueryParam:string|any;
    totalPendingSoftwareUpdates: number;
    ssoPartsUrl: string;
    deviceType: string;
    showDoorBanner: boolean;
    userAccessingCountryCode: string;
    isTronCountry: boolean;
    isIpUsbased: boolean;
    userRequestedURL: any;
    currentUser:User;
    announcementModals:string[];
    isAnnouncementModalOpen?: boolean;
    preferredLanguage?: string;
    preferredUnit?: string;
    softwarePendingCountList:{};
    showLFODTooltip: boolean;
    showLFODPremiumTooltip: boolean;
    showNewPermissionTooltip: boolean;
    showVideoLibraryTooltip: boolean;
    showVideoAddDescTooltip: boolean;
    showAttractScreenPopup: boolean;
    [key: string]: any;

    customUnsavedChangesPopupData?: any;
    isShowPopupBlockerMessage?: boolean;
    popupBlockerMessageData?: any;
    showFacilitySetupPopup: boolean;
    currentUrl: string;
    previousUrl: string;
}
